import React from "react";

const ComingSoonPopup = ({ isOpen, onClose, message }) => {
  if (!isOpen) return null;

  return (
    <div
      style={{
        position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)",
        display: "flex", alignItems: "center", justifyContent: "center",
        zIndex: 9999,
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: "#fff", borderRadius: "16px", padding: "32px 28px",
          maxWidth: "400px", width: "90%", textAlign: "center",
          boxShadow: "0 20px 60px rgba(0,0,0,0.25)",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* <div style={{ fontSize: "48px", marginBottom: "12px" }}>🚀</div> */}
        <p style={{ fontSize: "15px", fontWeight: "600", color: "#1a1a1a", marginBottom: "8px", lineHeight: "1.6" }}>
          {message || "Feature launching shortly — for more info reach us via WhatsApp or call"}{" "}
          <a href="tel:9289440049" style={{ color: "#1e5799", textDecoration: "none", fontWeight: "700" }}>9289440049</a>
        </p>
        {/* ponytail: Hindi line only for the default coming-soon copy */}
        {!message && (
          <p style={{ fontSize: "14px", color: "#555", lineHeight: "1.6", marginBottom: "20px" }}>
            Feature जल्द ही आ रहा है — जानकारी के लिए WhatsApp या कॉल करें{" "}
            <a href="tel:9289440049" style={{ color: "#1e5799", textDecoration: "none", fontWeight: "700" }}>9289440049</a>
          </p>
        )}
        <div style={{ display: "flex", gap: "10px", justifyContent: "center" }}>
          <a
            href="tel:+919289440049"
            style={{
              background: "#1e5799", color: "#fff", padding: "10px 22px",
              borderRadius: "50px", fontWeight: "700", fontSize: "14px",
              textDecoration: "none",
            }}
          >
            Call Us
          </a>
          <button
            onClick={onClose}
            style={{
              background: "#f1f5f9", color: "#333", padding: "10px 22px",
              borderRadius: "50px", fontWeight: "600", fontSize: "14px",
              border: "none", cursor: "pointer",
            }}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ComingSoonPopup;
